import "../../Styles/Home.css";
import "font-awesome/css/font-awesome.min.css";
import homeLogo from "../../Assets/home-main.svg";
import { MyTimeline, Footer, Project } from "../../Components";
import { Container, Row, Col } from "react-bootstrap";
import DynamicText from "./DynamicText.jsx";
import FontAwesome from "react-fontawesome";
import Particle from "../Particle";

const Home = () => {
  return (
    <>
   <Container fluid className="home-section"  id ="home" style={{ paddingLeft: "var(--bs-gutter-x,0rem)"}}>
         <Particle/> 
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 className="heading-name">
                I'M
                <strong className="main-name"> ABHINAV RAI</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <DynamicText />
              </div>
              <h6 className="heading">
                <FontAwesome className="fas fa-quote-left  " />
                Don't limit yourself. Many people limit themselves to what they
                think, they can do.You can go as far as your mind lets you.What
                you believe,remember,you can achieve.
                <FontAwesome className="fas fa-quote-right " />
              </h6>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img src={homeLogo} alt="home pic" className="img-fluid" />
            </Col>
          </Row>
        </Container>
      </Container>

      <MyTimeline />
      <Project  />

      <br />

      <Footer />
    </>
  );
};

export default Home;
